<script>
    import {dictionary, locale, _} from "svelte-i18n";
    import { onMount, onDestroy } from 'svelte';
    import {getOuterHeight, getOuterWidth} from './lib/Common.svelte';

    export let language = 'ru-RU';
    export let selected = 'instagram';
    export let setVkTexts = function () {};
    export let setOkTexts = function () {};
    export let setInstagramTexts = function () {};
    let showNotificationBubble = false;

    export let customTitleText = null;
    export let customDescriptionText = null;

    function onAutoregDisabledEvent(event) {
        let notification = document.createElement('div');
        notification.classList.add('notify-bubble');
        notification.classList.add('blockable__message');
        notification.classList.add('show');


        let message = null;
        switch (selected) {
            case 'vk':
                message = 'Парсинг целевой аудитории из Vk находится в разработке. Пока воспользуйтесь парсингом целевой аудитории из Инстаграм.';
                break;
            case 'ok':
                message = 'Парсинг целевой аудитории из Одноклассников находится в разработке. Пока воспользуйтесь парсингом целевой аудитории из Инстаграм.';
                break;
        }

        notification.innerHTML = message;

        try {
            event.detail.element.parentElement.style.position = 'relative';
            event.detail.element.parentElement.prepend(notification);

            notification.style.top = event.detail.element.offsetTop - notification.getBoundingClientRect().height - 11 + 'px';
            notification.style.left = event.detail.element.offsetLeft - ((notification.getBoundingClientRect().width - getOuterWidth(event.detail.element)) / 2) + 'px';

            setTimeout(() => {
                notification.classList.add('fade-out');
                setTimeout(() => {
                    notification.remove();
                }, 2000)
            }, 3000);
        } catch (err) {
            console.log(err);
        }
    }

    onMount(async () => {
        document.addEventListener('autoregDisabled', onAutoregDisabledEvent, false);
    });

    onDestroy(async () => {
        document.removeEventListener('autoregDisabled', onAutoregDisabledEvent);
    });


    dictionary.set({
        ru: {
            'intro': {
                'title': 'Проводите парсинг Инстаграм* аккаунтов в популярных соц. сетях:',
                'description': 'Нажмите на логотип для переключения',
            },
        },
        en: {
            'intro': {
                'title': 'Scrape from any social network:',
                'description': 'Click appropriate button',
            }
        },
    });

    switch (language) {
        case 'ru-RU':
            locale.set('ru');
            break;
        case 'en-US':
        default:
            locale.set('en');
            break;
    }

    async function handleSelect(event, target) {
        selected = target;

        if (selected !== 'instagram') {
            window.canAutoreg = false;
            if (selected === 'vk') {
                if (typeof setVkTexts === 'function') {
                    try {
                        setVkTexts();
                    } catch (err) { console.log(err) }
                }
            } else if (selected === 'ok') {
                if (typeof setOkTexts === 'function') {
                    try {
                        setOkTexts();
                    } catch (err) { console.log(err) }
                }
            }
        } else {
            window.canAutoreg = true;
            if (typeof setInstagramTexts === 'function') {
                try {
                    setInstagramTexts();
                } catch (err) { console.log(err) }
            }
        }
    }

</script>

<div class="widget-wrap">
    <div class="row">
        <div class="col-md-7 intro-block">
            <div class="title-wrap text-center text-md-end">
                {customTitleText ? customTitleText : $_('intro.title')}
            </div>
            <div class="description-wrap text-center text-md-end">
                {customDescriptionText ? customDescriptionText : $_('intro.description')}
            </div>
        </div>
        <div class="col-md-5 row buttons-block">
            <div class="col">
                <a href={'#'} class="select-btn" class:selected={(selected === 'instagram')} on:click|preventDefault={(e) => handleSelect(e, 'instagram')}>
                    <img src="/images/socials/i-instagram.png" alt="instagram" />
                </a>
            </div>
            <div class="col">
                <a href={'#'} class="select-btn" class:selected={(selected === 'vk')} on:click|preventDefault={(e) => handleSelect(e, 'vk')}>
                    <img src="/images/socials/i-vk.png" alt="vk" />
                </a>
            </div>
            <div class="col">
                <a href={'#'} class="select-btn" class:selected={(selected === 'ok')} on:click|preventDefault={(e) => handleSelect(e, 'ok')}>
                    <img src="/images/socials/i-ok.png" alt="ok" />
                </a>
            </div>
        </div>
    </div>
</div>

<div class="notify-bubble blockable__message {showNotificationBubble ? 'show' : 'd-none'}">
    Some message...
</div>

<style>
    .widget-wrap {
        max-width: 960px;
        margin-left: auto;
        margin-right: auto;

        line-height: 133px;

        background: linear-gradient(180deg, #ECF5FF 0%, rgba(236, 245, 255, 0) 100%);
        border-radius: 26px;

        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 400;
    }
    .widget-wrap img {
        max-width: 100%;
    }
    .widget-wrap .intro-block {
        padding: 38px;
    }
    .widget-wrap .title-wrap {
        font-size: 20px;
        line-height: 26px;
        color: #333333;
    }
    .widget-wrap .description-wrap {
        font-size: 16px;
        line-height: 26px;
        color: #333333;
    }
    .widget-wrap .buttons-block {
        margin-left: auto;
        margin-right: auto;
    }
    .select-btn img {
        border-radius: 50%;
    }
    .select-btn.selected img{
        border: 3px solid #0B8677;
    }



</style>